import { useQuery } from '@hooks/reactQuery';

import { getCrowdCellCard } from '@api/manageCrowdCells';

import { extractQueryParams } from '@utils/common';

import { CROWDCELL_CARD } from '@constants/queryKeys';

export const useQueryCrowdCellCard = (id: string) => {
	const {
		data: crowdCellCard,
		isInitialLoading,
	} = useQuery({
		queryKey: [
			CROWDCELL_CARD,
			id,
		],
		queryFn: extractQueryParams(getCrowdCellCard),
		enabled: [id],
		refetchOnWindowFocus: false,
	});

	return {
		crowdCellCard: crowdCellCard || null,
		isLoadingCrowdCellCard: isInitialLoading,
	};
};
